import React from "react";
import classNames from "classnames";
import { SectionTilesProps } from "../../../utils/SectionProps";
import { Link } from "react-router-dom";
import { jobs } from "../../../data/jobs";

const propTypes = {
  ...SectionTilesProps.types,
};

const defaultProps = {
  ...SectionTilesProps.defaults,
};

const CareerList = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {
  const outerClasses = classNames(
    "features-tiles section",
    topOuterDivider && "has-top-divider",
    bottomOuterDivider && "has-bottom-divider",
    hasBgColor && "has-bg-color",
    invertColor && "invert-color",
    className
  );

  const innerClasses = classNames(
    "testimonial-inner section-inner",
    topDivider && "has-top-divider",
    bottomDivider && "has-bottom-divider"
  );

  const tilesClasses = classNames(
    "tiles-wrap justify-content-center align-items-center px-1 mb-4"
  );

  const openJobs = jobs.filter((job) => job.isOpen);

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <div className={tilesClasses}>
            {openJobs.map((job) => (
              <div
                key={job.id}
                className="px-3 py-2 w-100 reveal-from-left"
                data-reveal-delay="100"
              >
                <Link
                  className="hover-career-list-link"
                  to={`/careers/${job.slug}`}
                >
                  <div className="tiles-item-career-list">
                    <li className="career-title text-sm m-0">{job.title}</li>
                    <p className="text-xxs m-0">
                      {job.positions} Position{job.positions !== 1 ? "s" : ""}
                    </p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

CareerList.propTypes = propTypes;
CareerList.defaultProps = defaultProps;

export default CareerList;
